import { createContext, useContext, useEffect, useMemo, useState, type ReactNode } from 'react';
import type { Location } from '@alexiarest/shared';
import { useQuery } from '@tanstack/react-query';
import { api } from '../api/client';

interface LocationState {
  locations: Location[];
  /** undefined = consolidado de todos los centros. */
  locationId?: string;
  setLocationId: (locationId?: string) => void;
  /** Escrituras antiguas o hechas desde consolidado se asignan a Principal. */
  writeLocationId: string;
}

const LocationContext = createContext<LocationState | null>(null);

export function LocationProvider({ children }: { children: ReactNode }): JSX.Element {
  const me = useQuery({ queryKey: ['me'], queryFn: () => api.getMe() });
  const locations = useMemo(
    () => (me.data?.locations ?? []).filter((location) => location.active),
    [me.data?.locations],
  );
  const [locationId, setLocationId] = useState<string | undefined>('principal');

  useEffect(() => {
    if (locationId && locations.length > 0 && !locations.some((l) => l.locationId === locationId)) {
      setLocationId(locations[0]?.locationId);
    }
  }, [locationId, locations]);

  const value = useMemo<LocationState>(
    () => ({
      locations,
      locationId,
      setLocationId,
      writeLocationId: locationId ?? locations[0]?.locationId ?? 'principal',
    }),
    [locationId, locations],
  );
  return <LocationContext.Provider value={value}>{children}</LocationContext.Provider>;
}

export function useLocationScope(): LocationState {
  const value = useContext(LocationContext);
  if (!value) throw new Error('useLocationScope debe usarse dentro de <LocationProvider>.');
  return value;
}
